import { AppState } from "../../../../redux/reducers";

// stores
import * as ProtocolStore from '../../../../redux/middleware/MedicalProtocolMiddleware';
import * as ContractConceptStore from '../../../../redux/middleware/ContractConceptMiddleware';
import * as ContractCommisionAgentStore from '../../../../redux/middleware/ContractCommissionAgentMiddleware';
import * as ContrectStore from '../../../../redux/middleware/ContractMiddleware';
import * as ConrtractCommissionAgentConceptStore from '../../../../redux/middleware/ContractCommissionAgentConceptMiddleware';

// models
import { ContractCommissionAgentConcept } from "../../../../models/Entities/Contracts/ContractCommissionAgentConcept";
import { ErrorType } from "../../../../models/HttpError";
import { Protocol } from "../../../../models/Entities/Protocols/Protocol";
import { Contract } from "../../../../models/Entities/Contracts/Contract";
import { ContractCommissionAgent } from "../../../../models/Entities/Contracts/ContractCommissionAgent";


/* Este control lo comparten el equipo del protocolo y los colaboradores del
   contrato. Lo que necesita de verdad es el contrato y el id del agente: el
   protocolo y el profesional son contexto del primer caso, no se usan al
   dibujar, y por eso son opcionales — un colaborador que no es profesional no
   tiene ninguno de los dos. */
interface IProps {
  CommissionAgentId: number | undefined;
  ContractId: number;
  PractitionerId?: string | undefined;
  ProtocolId?: number | undefined;
  disabled?: boolean;
  /** Bajada del encabezado. Sin esto habla del profesional en el protocolo. */
  subtitleText?: string;
  /** Texto del estado vacío. Sin esto habla del profesional en el protocolo. */
  emptyDescriptionText?: string;
};

interface ConnectedProps {
    isLoading: boolean;
    LoadedSuccessfully: boolean | undefined;
    FailOnLoading: boolean;
    ErrorOnLoading: ErrorType | undefined;
    isSaving: boolean;
    SavingSuccessfully: boolean | undefined;
    Protocol: Protocol;
    Contract: Contract;
    Concepts: ContractCommissionAgentConcept[];
    Agent: ContractCommissionAgent | undefined;
};

interface MedicalServicesDispatchProps {
    GetMedicalProtocolById: typeof ProtocolStore.actionCreators.GetMedicalProtocolById;
    GetAllContractsConcept: typeof ContractConceptStore.actionCreators.GetAllContractsConcept;
    GetAllContractCommissionAgents: typeof ContractCommisionAgentStore.actionCreators.GetAllContractCommissionAgents;
    GetAllContracts: typeof ContrectStore.actionCreators.GetAllContracts;
    GetAllContractCommissionAgentConceptsByCommissionAgentId: typeof ConrtractCommissionAgentConceptStore.actionCreators.GetAllContractCommissionAgentConceptsByCommissionAgentId;
};


export type Props = IProps & ConnectedProps & MedicalServicesDispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => ({
    isLoading: state.ContractCommissionAgentConcept?.isLoadingAll,
    LoadedSuccessfully: state.ContractCommissionAgentConcept?.successLoadingAll,
    FailOnLoading: state.ContractCommissionAgentConcept?.failOnLoadingAll,
    ErrorOnLoading: state.ContractCommissionAgentConcept?.error,
    isSaving: state.ContractCommissionAgentConcept?.isAddingNewOne || state.ContractCommissionAgentConcept?.isUpdatingOne,
    SavingSuccessfully: state.ContractCommissionAgentConcept?.successAddingNewOne || state.ContractCommissionAgentConcept?.successUpdatingOne,
    Protocol: state.MedicalProtocols?.list?.find((protocol: Protocol) => protocol.id === ownProps.ProtocolId) as Protocol,
    Contract: state.Contract?.list?.find((contract: Contract) => contract.id === ownProps.ContractId) as Contract,
    Agent: state.Contract?.list?.find((contract: Contract) => contract.id === ownProps.ContractId)?.commissionAgents?.find((commissionAgent: ContractCommissionAgent) => commissionAgent.id === ownProps.CommissionAgentId) as ContractCommissionAgent,
    Concepts: state.Contract?.list?.find((contract: Contract) => contract.id === ownProps.ContractId)?.commissionAgents?.find((commissionAgent: ContractCommissionAgent) => commissionAgent.id === ownProps.CommissionAgentId)?.Concepts as ContractCommissionAgentConcept[] || []
})

export const mapDispatchToProps = (

    //ownProps.CommissionAgentId && dispatch(ConrtractCommissionAgentConceptStore.actionCreators.GetAllContractCommissionAgentConceptsByCommissionAgentId(ownProps.CommissionAgentId, ownProps.ContractId));

    {
    ...ProtocolStore.actionCreators,
    ...ContractConceptStore.actionCreators,
    ...ContractCommisionAgentStore.actionCreators,
    ...ContrectStore.actionCreators,
    ...ConrtractCommissionAgentConceptStore.actionCreators,
    //GetAllContractCommissionAgentConceptsByCommissionAgentId: (CommissionAgentid: number, ContractId: number) => dispatch(ConrtractCommissionAgentConceptStore.actionCreators.GetAllContractCommissionAgentConceptsByCommissionAgentId(CommissionAgentid, ContractId)),
    }
);
